import React from "react";
import { usePWA } from "../hooks/usePWA";
import Icon from "./Icon";

const PWAStatusIndicator = () => {
  const { isOnline, isAppOffline } = usePWA();

  if (isOnline) {
    return null; // Não mostra nada quando está online
  }

  return (
    <div className="pwa-offline-indicator">
      <div
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          right: "0",
          background: "linear-gradient(135deg, #ef4444, #dc2626)",
          color: "white",
          padding: "8px 16px",
          zIndex: 10000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          fontSize: "14px",
          fontWeight: "500",
          boxShadow: "0 2px 8px rgba(239, 68, 68, 0.3)",
          animation: "slideDown 0.3s ease-out",
        }}
      >
        <Icon name="wifi-x" size={16} />
        <span>
          Você está offline - Algumas funcionalidades podem estar limitadas
        </span>
        <Icon name="alert-circle" size={16} />
      </div>

      <style jsx>{`
        @keyframes slideDown {
          from {
            transform: translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default PWAStatusIndicator;
